<div
  class="copilot-panel-shell"
  [class.copilot-panel-shell--open]="(isOpen$ | async) === true"
  [class.copilot-panel-shell--drawer-open]="contextDrawerOpen"
  [style.width.px]="(isOpen$ | async) ? panelWidth : 0"
>
  <div class="copilot-divider"></div>
  <div
    class="copilot-drag-strip"
    (pointerdown)="onResizePointerDown($event)"
  ></div>
  <app-sidepanel
    class="copilot-sidepanel"
    [isVisible]="(isOpen$ | async) === true"
    [enableAnimation]="true"
    (closed)="onClose()"
    [trackingCtx]="{ location: 'Copilot' }"
  >
  <app-sidepanel-header
    [name]="'copilot.panelTitle' | translate"
    [subtitle]="'copilot.poweredByShort' | translate"
    [subtitleTooltip]="'copilot.poweredBy' | translate"
    [iconType]="'assistant'"
    (closed)="onClose()"
  >
    <ng-template #rightSide>
      <div class="copilot-header-actions" role="toolbar" [attr.aria-label]="'copilot.moreActions' | translate">
        <button
          *ngIf="panelView === 'guide' || panelView === 'usage' || panelView === 'skills'"
          mat-icon-button
          class="copilot-header-btn"
          [matTooltip]="'copilot.guidance.backTooltip' | translate"
          [attr.aria-label]="'copilot.guidance.backTooltip' | translate"
          (click)="showChatView()"
        >
          <mat-icon>arrow_back</mat-icon>
        </button>
        <button
          *ngIf="panelView === 'chat'"
          mat-icon-button
          class="copilot-header-btn"
          [disabled]="(isSending$ | async) === true"
          [matTooltip]="'copilot.newChat' | translate"
          [attr.aria-label]="'copilot.newChat' | translate"
          (click)="onNewChat()"
        >
          <mat-icon>note_add</mat-icon>
        </button>
        <button
          mat-icon-button
          class="copilot-header-btn"
          [matMenuTriggerFor]="copilotMenu"
          [matTooltip]="'copilot.moreActions' | translate"
          [attr.aria-label]="'copilot.moreActions' | translate"
          (click)="onMoreActionsClick()"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>
    </ng-template>
  </app-sidepanel-header>

  <mat-menu #copilotMenu="matMenu" xPosition="before" class="copilot-header-menu" panelClass="copilot-header-menu">
    <button mat-menu-item (click)="showUsageView()">
      <mat-icon>data_usage</mat-icon>
      <span>{{ 'copilot.usage.menuItem' | translate }}</span>
    </button>
    <button mat-menu-item (click)="showGuideView()">
      <mat-icon>help_outline</mat-icon>
      <span>{{ 'copilot.guidance.openTooltip' | translate: { name: assistantDisplayName } }}</span>
    </button>
  </mat-menu>

  <div class="copilot-body" fxLayout="column" fxFlex>
    <div class="copilot-chrome" *ngIf="panelView === 'chat'">
      <div
        class="copilot-tabs"
        *ngIf="((conversations$ | async)?.length || 0) > 1"
        role="tablist"
        [attr.aria-label]="'copilot.conversations' | translate"
      >
        <div
          class="copilot-tab"
          *ngFor="let tab of conversations$ | async; trackBy: trackByConversation"
          role="tab"
          [class.copilot-tab--active]="tab.id === (activeConversationId$ | async)"
          [attr.aria-selected]="tab.id === (activeConversationId$ | async)"
        >
          <button
            type="button"
            class="copilot-tab__select"
            [disabled]="(isSending$ | async) === true"
            (click)="onSelectConversation(tab.id)"
          >
            <span class="copilot-tab__title">{{ conversationTitle(tab) }}</span>
          </button>
          <button
            type="button"
            class="copilot-tab__close"
            [disabled]="(isSending$ | async) === true"
            [attr.aria-label]="'copilot.closeConversation' | translate"
            (click)="onCloseConversation($event, tab.id)"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="contextControls"></ng-container>
    </div>
    <ng-container *ngIf="panelView === 'guide'">
      <div class="copilot-guide" fxFlex>
        <div class="copilot-guide__header">
          <h2 class="copilot-guide__title">{{ 'copilot.guidance.title' | translate: { name: assistantDisplayName } }}</h2>
          <p class="copilot-guide__intro">{{ 'copilot.guidance.intro' | translate }}</p>
        </div>

        <section class="copilot-guide__section" aria-labelledby="copilot-guide-capabilities">
          <h3 id="copilot-guide-capabilities" class="copilot-guide__section-title">
            {{ 'copilot.guidance.capabilitiesTitle' | translate }}
          </h3>
          <div class="copilot-guide__accordion">
            <div class="copilot-guide__item" *ngFor="let cap of guidanceCapabilities">
              <button
                type="button"
                class="copilot-guide__item-header"
                [attr.aria-expanded]="isGuidanceExpanded(cap.id)"
                (click)="toggleGuidanceSection(cap.id)"
              >
                <span class="copilot-guide__item-title">{{ cap.titleKey | translate }}</span>
                <mat-icon class="copilot-guide__item-chevron">
                  {{ isGuidanceExpanded(cap.id) ? 'expand_less' : 'expand_more' }}
                </mat-icon>
              </button>
              <div class="copilot-guide__item-body" *ngIf="isGuidanceExpanded(cap.id)">
                <p class="copilot-guide__item-desc">{{ cap.descriptionKey | translate }}</p>
                <div class="copilot-guide__prompts">
                  <button
                    type="button"
                    class="copilot-guide__prompt"
                    *ngFor="let promptKey of cap.promptKeys"
                    (click)="onGuidancePrompt(promptKey)"
                  >
                    <span>{{ promptKey | translate }}</span>
                    <mat-icon>arrow_forward</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="copilot-guide__section" aria-labelledby="copilot-guide-access">
          <h3 id="copilot-guide-access" class="copilot-guide__section-title">
            {{ 'copilot.guidance.access.title' | translate: { name: assistantDisplayName } }}
          </h3>
          <p class="copilot-guide__section-body">{{ 'copilot.guidance.access.body' | translate: { name: assistantDisplayName } }}</p>
        </section>

        <section class="copilot-guide__section" aria-labelledby="copilot-guide-tips">
          <h3 id="copilot-guide-tips" class="copilot-guide__section-title">
            {{ 'copilot.guidance.tips.title' | translate }}
          </h3>
          <ul class="copilot-guide__tips">
            <li>{{ 'copilot.guidance.tips.dates' | translate: { name: assistantDisplayName } }}</li>
            <li>{{ 'copilot.guidance.tips.mentions' | translate }}</li>
            <li>{{ 'copilot.guidance.tips.followUps' | translate: { name: assistantDisplayName } }}</li>
          </ul>
        </section>
      </div>
    </ng-container>

    <ng-container *ngIf="panelView === 'usage'">
      <div class="copilot-quota" fxFlex>
        <div class="copilot-quota__header">
          <h2 class="copilot-quota__title">{{ 'copilot.usage.title' | translate }}</h2>
          <p class="copilot-quota__intro">{{ 'copilot.usage.intro' | translate }}</p>
        </div>

        <div class="copilot-quota__loading" *ngIf="usageLoading" role="status">
          {{ 'copilot.usage.loading' | translate }}
        </div>

        <div class="copilot-quota__error" *ngIf="!usageLoading && usageError" role="alert">
          <p>{{ 'copilot.usage.error' | translate }}</p>
          <button type="button" class="copilot-quota__retry" (click)="showUsageView()">
            {{ 'copilot.usage.retry' | translate }}
          </button>
        </div>

        <ng-container *ngIf="!usageLoading && tokenQuota as quota">
          <section class="copilot-quota__card" aria-labelledby="copilot-usage-daily">
            <div class="copilot-quota__card-head">
              <h3 id="copilot-usage-daily" class="copilot-quota__card-title">
                {{ 'copilot.usage.dailyTitle' | translate }}
              </h3>
              <span class="copilot-quota__pct">
                {{ 'copilot.usage.percentUsed' | translate:{ percent: (quota.daily.percentUsed * 100) | number:'1.0-0' } }}
              </span>
            </div>
            <div
              class="copilot-quota__track"
              role="progressbar"
              [attr.aria-valuemin]="0"
              [attr.aria-valuemax]="quota.daily.limit"
              [attr.aria-valuenow]="quota.daily.used"
              [attr.aria-label]="'copilot.usage.dailyTitle' | translate"
            >
              <div
                class="copilot-quota__fill"
                [class.copilot-quota__fill--warn]="quotaTone(quota.daily.percentUsed) === 'warn'"
                [class.copilot-quota__fill--over]="quotaTone(quota.daily.percentUsed) === 'over'"
                [style.width]="quotaBarWidth(quota.daily.percentUsed)"
              ></div>
            </div>
            <p class="copilot-quota__meta">
              {{
                'copilot.usage.usedOfLimit'
                  | translate
                    : {
                        used: formatTokenCount(quota.daily.used),
                        limit: formatTokenCount(quota.daily.limit)
                      }
              }}
            </p>
            <p class="copilot-quota__reset">
              {{ 'copilot.usage.resetsDaily' | translate }}
            </p>
          </section>

          <section class="copilot-quota__card" aria-labelledby="copilot-usage-monthly">
            <div class="copilot-quota__card-head">
              <h3 id="copilot-usage-monthly" class="copilot-quota__card-title">
                {{ 'copilot.usage.monthlyTitle' | translate }}
              </h3>
              <span class="copilot-quota__pct">
                {{ 'copilot.usage.percentUsed' | translate:{ percent: (quota.monthly.percentUsed * 100) | number:'1.0-0' } }}
              </span>
            </div>
            <div
              class="copilot-quota__track"
              role="progressbar"
              [attr.aria-valuemin]="0"
              [attr.aria-valuemax]="quota.monthly.limit"
              [attr.aria-valuenow]="quota.monthly.used"
              [attr.aria-label]="'copilot.usage.monthlyTitle' | translate"
            >
              <div
                class="copilot-quota__fill"
                [class.copilot-quota__fill--warn]="quotaTone(quota.monthly.percentUsed) === 'warn'"
                [class.copilot-quota__fill--over]="quotaTone(quota.monthly.percentUsed) === 'over'"
                [style.width]="quotaBarWidth(quota.monthly.percentUsed)"
              ></div>
            </div>
            <p class="copilot-quota__meta">
              {{
                'copilot.usage.usedOfLimit'
                  | translate
                    : {
                        used: formatTokenCount(quota.monthly.used),
                        limit: formatTokenCount(quota.monthly.limit)
                      }
              }}
            </p>
            <p class="copilot-quota__reset">
              {{ 'copilot.usage.resetsMonthly' | translate }}
            </p>
          </section>

          <section
            class="copilot-quota__card copilot-quota__top-users"
            *ngIf="showTopUsersSection"
            aria-labelledby="copilot-usage-top-users"
          >
            <div class="copilot-quota__card-head">
              <h3 id="copilot-usage-top-users" class="copilot-quota__card-title">
                {{ 'copilot.usage.topUsersTitle' | translate }}
              </h3>
            </div>
            <p class="copilot-quota__reset">{{ 'copilot.usage.topUsersIntro' | translate }}</p>
            <p class="copilot-quota__meta" *ngIf="!topUsersToday.length">
              {{ 'copilot.usage.topUsersEmpty' | translate }}
            </p>
            <ol class="copilot-quota__top-list" *ngIf="topUsersToday.length">
              <li class="copilot-quota__top-row" *ngFor="let row of topUsersToday">
                <span class="copilot-quota__top-rank">{{ row.rank }}</span>
                <span class="copilot-quota__top-name" [title]="row.userId">{{ row.name }}</span>
                <span class="copilot-quota__top-tokens">
                  {{ 'copilot.usage.topUsersTokens' | translate: { count: formatTokenCount(row.tokens) } }}
                </span>
              </li>
            </ol>
          </section>
        </ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="panelView === 'skills'">
      <div class="copilot-skills" fxFlex>
        <div class="copilot-skills__header">
          <h2 class="copilot-skills__title">{{ 'copilot.skills.title' | translate }}</h2>
          <p class="copilot-skills__intro">{{ 'copilot.skills.intro' | translate }}</p>
          <p class="copilot-skills__count" *ngIf="skillsList.length">
            {{ 'copilot.skills.availableCount' | translate: { count: skillsAvailableCount() } }}
          </p>
        </div>

        <ul class="copilot-skills__list" role="list">
          <li
            class="copilot-skills__item"
            *ngFor="let skill of skillsList"
            [class.copilot-skills__item--available]="skill.entitled"
            [class.copilot-skills__item--locked]="!skill.entitled"
          >
            <div class="copilot-skills__item-main">
              <div class="copilot-skills__item-head">
                <h3 class="copilot-skills__item-title">{{ skill.name }}</h3>
                <span
                  class="copilot-skills__badge"
                  [class.copilot-skills__badge--available]="skill.entitled"
                  [class.copilot-skills__badge--locked]="!skill.entitled"
                >
                  {{
                    (skill.entitled ? 'copilot.skills.available' : 'copilot.skills.locked')
                      | translate
                  }}
                </span>
              </div>
              <p class="copilot-skills__item-desc">{{ skill.description }}</p>
            </div>
            <div class="copilot-skills__item-actions">
              <button
                *ngIf="skill.entitled"
                type="button"
                class="copilot-skills__action"
                (click)="onTrySkillPrompt(skill)"
              >
                {{ 'copilot.skills.tryPrompt' | translate }}
              </button>
              <button
                *ngIf="!skill.entitled"
                type="button"
                class="copilot-skills__action copilot-skills__action--secondary"
                (click)="onUnlockSkill(skill)"
              >
                {{ 'copilot.skills.unlock' | translate }}
              </button>
            </div>
          </li>
        </ul>
      </div>
    </ng-container>

    <ng-container *ngIf="panelView === 'chat'">
    <!-- Temporarily hidden: first-run "Connect live workspace data?" prompt.
    <div class="copilot-livedata-disclosure" *ngIf="(liveDataDisclosurePending$ | async) === true">
      <p class="copilot-livedata-disclosure__title">
        {{ 'copilot.liveData.disclosureTitle' | translate }}
      </p>
      <p class="copilot-livedata-disclosure__body">
        {{ 'copilot.liveData.disclosureBody' | translate }}
      </p>
      <div class="copilot-livedata-disclosure__actions">
        <button type="button" mat-stroked-button (click)="onDeclineLiveDataDisclosure()">
          {{ 'copilot.liveData.disclosureDecline' | translate }}
        </button>
        <button type="button" mat-flat-button color="primary" (click)="onConfirmLiveDataDisclosure()">
          {{ 'copilot.liveData.disclosureAccept' | translate }}
        </button>
      </div>
    </div>
    -->
    <div
      class="copilot-messages"
      #scrollContainer
      role="log"
      aria-live="polite"
      fxFlex
      [class.is-scroll-lock]="suppressStickToBottom"
    >
      <ng-container *ngIf="messages$ | async as messages">
        <div class="copilot-empty" *ngIf="messages.length === 0">
          <div class="copilot-empty__hero">
            <div class="copilot-empty__badge" *ngIf="showLargeEmptyBadge" [class.copilot-empty__badge--compact]="hasSeenEmptyState">
              <mat-icon>assistant</mat-icon>
            </div>
            <h2 class="copilot-empty__headline" [class.copilot-empty__headline--brief]="hasBriefGreeting">
              {{ emptyStateHeadline }}
            </h2>
            <p
              class="copilot-empty__subtext"
              [class.copilot-empty__subtext--brief]="hasBriefGreeting"
              *ngIf="emptyStateSubtext"
            >{{ emptyStateSubtext }}</p>
          </div>
          <div class="copilot-empty__suggestions">
            <p class="copilot-suggestions__label">
              {{
                (hasRouteSpecificSuggestions ? 'copilot.suggestions.forThisPage' : 'copilot.suggestions.tryAsking')
                  | translate
              }}
            </p>
            <div class="copilot-suggestions">
              <button
                type="button"
                class="copilot-suggestion"
                *ngFor="let item of visibleSuggestionItems"
                [attr.aria-label]="suggestionAriaLabel(item.label)"
                (click)="onSuggestion(item.key)"
              >
                <mat-icon class="copilot-suggestion__icon" aria-hidden="true">{{ item.icon }}</mat-icon>
                <span class="copilot-suggestion__text">{{ item.label }}</span>
              </button>
            </div>
          </div>
        </div>

        <div
          class="copilot-row"
          *ngFor="let message of messages; trackBy: trackByMessage"
          [class.copilot-row--user]="message.role === 'user'"
          [class.copilot-row--assistant]="message.role === 'assistant'"
        >
          <div class="copilot-avatar" *ngIf="message.role === 'assistant'" aria-hidden="true">
            <mat-icon>assistant</mat-icon>
          </div>

          <div
            class="copilot-msg-col"
            [class.copilot-msg-col--assistant]="message.role === 'assistant'"
          >
            <div
              class="answer__trace"
              *ngIf="message.role === 'assistant' && message.toolSteps?.length"
            >
              <div
                *ngFor="let step of message.toolSteps; trackBy: toolStepTrackBy"
                class="answer__trace-step"
                [class.done]="step.done || !message.pending"
              >
                {{ toolStepMark(step, message.pending) }} {{ step.text }}
                <span class="answer__trace-tool">{{ step.tool }}</span>
              </div>
            </div>

            <div
              class="copilot-typing"
              *ngIf="message.role === 'assistant' && message.pending && !hasAssistantText(message)"
              [attr.aria-label]="message.statusLabel || (assistantDisplayName + ' is typing')"
            >
              <span></span><span></span><span></span>
            </div>

          <div
            class="copilot-bubble"
            *ngIf="message.role === 'user' || !!message.error || hasAssistantText(message)"
            [class.copilot-bubble--user]="message.role === 'user'"
            [class.copilot-bubble--assistant]="message.role === 'assistant'"
            [class.copilot-bubble--error]="message.error"
          >

            <p
              class="copilot-degraded-note"
              *ngIf="message.role === 'assistant' && !message.pending && message.answerSource === 'deterministic'"
            >
              <mat-icon aria-hidden="true">offline_bolt</mat-icon>
              {{ 'copilot.degraded.banner' | translate }}
            </p>

            <div
              class="copilot-msg-header"
              *ngIf="message.role === 'assistant' && (message.persona || message.liveData || message.toolChecks?.length)"
            >
              <span class="copilot-persona" *ngIf="message.persona as persona">
                {{ persona.displayName }}
                <span class="copilot-persona__spark" aria-hidden="true">✦</span>
              </span>
              <span
                class="copilot-live-badge"
                *ngIf="message.liveData?.active"
              >{{ message.liveData.label }}</span>
              <span
                class="copilot-tool-check"
                *ngFor="let check of message.toolChecks"
              >{{ check.label }}{{ check.simulated ? ' — simulated' : '' }}</span>
            </div>

            <p
              class="copilot-scope-crumb"
              *ngIf="message.role === 'assistant' && message.conversationScope?.narrowed && message.conversationScope?.label"
            >
              {{ 'copilot.scope.narrowed' | translate: { label: message.conversationScope.label, name: (message.persona?.displayName || assistantDisplayName) } }}
            </p>

            <p
              *ngIf="message.role === 'assistant' && !message.pending && !message.error && !message.liveData && isFirstAssistantMessage(message, messages)"
              class="copilot-source-chip"
            >
              {{ liveDataSourceLabel(currentLiveDataStatus, message.tool) }}
            </p>

            <ng-container *ngIf="message.role === 'user'">
              <span class="user-message-inline" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="6px">
                <ng-container *ngFor="let seg of userMessageSegments(message.content, message.wire); trackBy: userMessagePartTrackBy">
                  <span *ngIf="seg.kind === 'text'" class="user-message-text">{{ seg.text }}</span>
                  <span
                    *ngIf="seg.kind === 'mention'"
                    class="mention-chip mention-chip-readonly"
                    [class.mention-chip-group]="seg.entityType === 'group'"
                  >
                    <span class="mention-chip-at">@</span><span class="mention-chip-label">{{ seg.label }}</span>
                  </span>
                </ng-container>
              </span>
            </ng-container>

            <markdown
              *ngIf="message.role === 'assistant' && hasAssistantText(message) && !message.shortFormat"
              class="copilot-markdown"
              [data]="message.content"
            ></markdown>
            <p
              *ngIf="message.role === 'assistant' && hasAssistantText(message) && message.shortFormat"
              class="copilot-short-format-answer"
            >
              <ng-container *ngFor="let seg of answerSegments(message)">
                <span *ngIf="seg.kind === 'text'">{{ seg.text }}</span>
                <strong *ngIf="seg.kind === 'bold'">{{ seg.text }}</strong>
                <button
                  *ngIf="seg.kind === 'link'"
                  type="button"
                  class="copilot-report-pill"
                  (click)="openReportLink(seg.link)"
                >
                  <mat-icon aria-hidden="true">open_in_new</mat-icon>
                  {{ seg.text }}
                </button>
              </ng-container>
            </p>
            <p
              *ngIf="message.shortFormat?.disclaimer"
              class="copilot-short-format-disclaimer"
            >
              {{ message.shortFormat.disclaimer }}
            </p>

            <div
              class="copilot-short-format-toggles"
              *ngIf="shortFormatVisualToggles(message) as toggles"
            >
              <button
                *ngIf="toggles.trend"
                type="button"
                class="copilot-short-format-toggle"
                [class.is-active]="isShortFormatTrendOpen(message.id)"
                (mousedown)="$event.preventDefault()"
                (click)="toggleShortFormatTrend(message.id, $event)"
              >
                {{ isShortFormatTrendOpen(message.id) ? 'Hide the trend' : 'See the trend' }}
              </button>
              <button
                *ngIf="toggles.people"
                type="button"
                class="copilot-short-format-toggle"
                [class.is-active]="isShortFormatPeopleOpen(message.id)"
                (mousedown)="$event.preventDefault()"
                (click)="toggleShortFormatPeople(message.id, $event)"
              >
                {{ isShortFormatPeopleOpen(message.id) ? 'Hide the people' : 'See the people' }}
              </button>
              <button
                *ngIf="toggles.approach"
                type="button"
                class="copilot-short-format-toggle"
                [class.is-active]="isShortFormatApproachOpen(message.id)"
                (mousedown)="$event.preventDefault()"
                (click)="toggleShortFormatApproach(message.id, $event)"
              >
                {{ isShortFormatApproachOpen(message.id) ? 'Hide the suggested approach' : 'See the suggested approach' }}
              </button>
            </div>
            <div
              class="copilot-unused-report-links"
              *ngIf="!message.pending && !message.shortFormat && unusedReportLinks(message).length"
            >
              <button
                *ngFor="let link of unusedReportLinks(message)"
                type="button"
                class="copilot-report-pill"
                (click)="openReportLink(link)"
              >
                <mat-icon aria-hidden="true">open_in_new</mat-icon>
                {{ link.label }}
              </button>
            </div>

            <div class="copilot-usage-chips" *ngIf="!message.pending && message.usageChips?.length">
              <span class="copilot-usage-chip" *ngFor="let chip of message.usageChips">
                {{ chip.label }} {{ chip.hours }}h
              </span>
            </div>

            <div
              class="copilot-charts"
              *ngIf="showLiveChart(message)"
            >
              <app-copilot-chart
                *ngFor="let chart of message.charts"
                [chart]="chart"
              ></app-copilot-chart>
            </div>

            <div
              class="copilot-tables"
              *ngIf="showLiveTable(message)"
            >
              <app-copilot-table
                *ngFor="let table of peopleTables(message); trackBy: tableTrackBy"
                [table]="table"
              ></app-copilot-table>
            </div>

            <app-copilot-decision-summary
              *ngIf="!message.pending && message.role === 'assistant' && message.decision"
              [decision]="message.decision"
              [coachingSuggestions]="message.coachingSuggestions"
              [debugMode]="isDevMode"
            ></app-copilot-decision-summary>

            <p *ngIf="clarificationHint(message) as hint" class="copilot-clarification">
              {{ hint }}
            </p>

            <p
              class="copilot-caveat-note"
              *ngFor="let note of caveatNotes(message)"
            >
              <mat-icon aria-hidden="true">info_outline</mat-icon>
              {{ note }}
            </p>

            <p class="copilot-scope-echo" *ngIf="!message.pending && message.scopeEcho">
              <mat-icon aria-hidden="true">filter_alt</mat-icon>
              {{ message.scopeEcho }}
            </p>

            <p
              class="copilot-soft-hint"
              *ngIf="!message.pending && message.softHint"
            >
              {{ message.softHint }}
            </p>

            <div class="copilot-actions" *ngIf="!message.shortFormat && message.actions?.length">
              <button
                class="copilot-action-chip"
                *ngFor="let action of message.actions"
                [class.copilot-action-chip--nav]="!!action.route"
                [class.copilot-action-chip--dig]="action.type === 'dig_into'"
                (click)="onActionClick(action, message)"
              >
                <mat-icon *ngIf="action.route || action.type === 'dig_into'" class="copilot-action-chip__icon">
                  {{ action.icon || (action.type === 'dig_into' ? 'person_search' : 'arrow_forward') }}
                </mat-icon>
                <span>{{ action.label }}</span>
              </button>
            </div>

            <div class="copilot-help-links" *ngIf="message.helpfulLinks?.length">
              <p class="copilot-help-links__title">
                {{ 'copilot.helpfulLinks.title' | translate }}
              </p>
              <button type="button" class="copilot-help-link" *ngFor="let link of message.helpfulLinks" (click)="onHelpLinkClick(link)">
                <mat-icon>open_in_new</mat-icon>
                <span>{{ link.title }}</span>
              </button>
            </div>

            <!-- Recommendation card (legacy CoS). Hidden on short-format live cards. -->
            <div
              class="copilot-recommendation"
              *ngIf="!message.pending && !message.shortFormat && message.recommendationCard as card"
            >
              <p class="copilot-recommendation__title">{{ card.title }}</p>
              <p class="copilot-recommendation__body" *ngIf="card.body">{{ card.body }}</p>
              <!-- Temporarily hidden: recommendation action buttons not needed yet. -->
              <div class="copilot-recommendation__actions" *ngIf="false">
                <button
                  type="button"
                  class="copilot-recommendation__btn"
                  *ngFor="let action of card.actions"
                  [class.copilot-recommendation__btn--primary]="action.primary"
                  (click)="onRecommendationAction(action, card, message)"
                >
                  {{ action.label }}
                </button>
              </div>
              <div class="copilot-recommendation__draft">
                <p class="copilot-recommendation__draft-label">
                  {{ recommendationDraftLabel(card) }}
                </p>
                <textarea
                  class="copilot-recommendation__draft-text"
                  rows="4"
                  [value]="recommendationDraftText(card, message.id)"
                  (input)="onRecommendationDraftInput(message.id, $any($event.target).value)"
                ></textarea>
              </div>
              <ng-container *ngIf="message.coachingSuggestions as tips">
                <ng-container *ngFor="let coaching of tips">
                  <ul
                    class="copilot-coaching__follow-ups"
                    *ngIf="coaching.followUpActions?.length"
                  >
                    <li
                      class="copilot-coaching__follow-up"
                      *ngFor="let tip of coaching.followUpActions"
                    >
                      {{ tip }}
                    </li>
                  </ul>
                </ng-container>
              </ng-container>
            </div>

            <!-- Standalone coaching only when there is no decision card and no recommendation card. -->
            <div
              class="copilot-coaching"
              *ngIf="showCoachingCard(message)"
            >
              <div class="copilot-coaching__card" *ngFor="let coaching of message.coachingSuggestions; let i = index">
                <p class="copilot-coaching__title">
                  {{ 'copilot.coaching.title' | translate }}
                </p>
                <p class="copilot-coaching__approach">{{ coaching.approach }}</p>
                <div class="copilot-coaching__draft">
                  <p class="copilot-coaching__draft-label">
                    {{ 'copilot.coaching.draftLabel' | translate }}
                  </p>
                  <div class="copilot-coaching__draft-row">
                    <textarea
                      class="copilot-coaching__draft-text"
                      rows="4"
                      [value]="draftText(coaching, message.id, i)"
                      [attr.aria-label]="'copilot.coaching.draftLabel' | translate"
                      (input)="onDraftInput(coaching, message.id, i, $any($event.target).value)"
                    ></textarea>
                    <button
                      type="button"
                      mat-icon-button
                      class="copilot-coaching__copy"
                      [matTooltip]="draftCopyTooltip(message.id, i)"
                      [attr.aria-label]="draftCopyTooltip(message.id, i)"
                      (click)="onCopyDraft(coaching, message.id, i)"
                    >
                      <mat-icon>{{ copiedDraftKey === draftKey(message.id, i) ? 'check' : 'content_copy' }}</mat-icon>
                    </button>
                  </div>
                </div>
                <ul
                  class="copilot-coaching__follow-ups"
                  *ngIf="coaching.followUpActions?.length"
                >
                  <li
                    class="copilot-coaching__follow-up"
                    *ngFor="let tip of coaching.followUpActions"
                  >
                    {{ tip }}
                  </li>
                </ul>
              </div>
            </div>

            <div class="copilot-usage" *ngIf="message.usage as usage" [matTooltip]="tokenTooltip(message)">
              <mat-icon class="copilot-usage__icon">toll</mat-icon>
              <span>{{ 'copilot.tokens.label' | translate: { count: usage.totalTokens } }}</span>
            </div>

            <div class="copilot-message-actions" *ngIf="showMessageActions(message)">
              <button
                type="button"
                mat-icon-button
                class="copilot-message-action"
                *ngIf="showMessageFeedback(message)"
                [class.copilot-message-action--active]="message.feedbackRating === 'helpful'"
                [matTooltip]="'copilot.feedback.helpful' | translate"
                [attr.aria-label]="'copilot.feedback.helpful' | translate"
                [attr.aria-pressed]="message.feedbackRating === 'helpful'"
                (click)="onFeedback(message, 'helpful')"
              >
                <mat-icon>{{ message.feedbackRating === 'helpful' ? 'thumb_up' : 'thumb_up_off_alt' }}</mat-icon>
              </button>
              <button
                type="button"
                mat-icon-button
                class="copilot-message-action"
                *ngIf="showMessageFeedback(message)"
                [class.copilot-message-action--active]="message.feedbackRating === 'not_helpful'"
                [matTooltip]="'copilot.feedback.notHelpful' | translate"
                [attr.aria-label]="'copilot.feedback.notHelpful' | translate"
                [attr.aria-pressed]="message.feedbackRating === 'not_helpful'"
                (click)="onFeedback(message, 'not_helpful')"
              >
                <mat-icon>{{ message.feedbackRating === 'not_helpful' ? 'thumb_down' : 'thumb_down_off_alt' }}</mat-icon>
              </button>
              <button
                type="button"
                mat-icon-button
                class="copilot-message-action"
                [matTooltip]="copyTooltip(message)"
                [attr.aria-label]="copyTooltip(message)"
                (click)="onCopyMessage(message)"
              >
                <mat-icon>{{ copiedMessageId === message.id ? 'check' : 'content_copy' }}</mat-icon>
              </button>
              <button
                type="button"
                mat-icon-button
                class="copilot-message-action"
                *ngIf="message.retryable !== false"
                [matTooltip]="'copilot.message.retry' | translate"
                [attr.aria-label]="'copilot.message.retry' | translate"
                [disabled]="(isSending$ | async) === true"
                (click)="onRetryMessage(message)"
              >
                <mat-icon>refresh</mat-icon>
              </button>
            </div>
          </div>
          </div>

          <div
            class="copilot-user-avatar"
            *ngIf="message.role === 'user'"
            aria-hidden="true"
          >
            <app-avatar
              [name]="userDisplayName"
              [size]="30"
              [textSizeRatio]="30 / 11"
              bgColor="#0166FF"
              fgColor="#FFFFFF"
            ></app-avatar>
          </div>
        </div>
      </ng-container>
    </div>

    <ng-container *ngTemplateOutlet="composerForm"></ng-container>
    </ng-container>

    <ng-template #contextControls>
      <div class="copilot-context-bar">
        <ng-container *ngIf="liveDataContext$ | async as ctx">
          <button
            type="button"
            class="copilot-context-chip"
            [class.copilot-context-chip--open]="contextDrawerOpen"
            [class.copilot-context-chip--highlight]="scopeBarHighlighted(activeClarification$ | async)"
            [disabled]="(isSending$ | async) === true"
            [attr.aria-label]="'copilot.context.configure' | translate"
            aria-haspopup="dialog"
            [attr.aria-expanded]="contextDrawerOpen"
            (click)="onContentAndFiltersClick()"
          >
            <mat-icon
              *ngIf="multiPersonaEnabled"
              class="copilot-context-chip__icon"
              aria-hidden="true"
            >psychology</mat-icon>
            <span
              *ngIf="multiPersonaEnabled && personalitySummary()"
              class="copilot-context-chip__summary"
            >{{ personalitySummary() }}</span>
            <ng-container *ngIf="ctx.liveData === 'connected' || ctx.liveData === 'connecting'">
              <span
                *ngIf="multiPersonaEnabled && personalitySummary()"
                class="copilot-context-chip__dot"
                aria-hidden="true"
              >·</span>
              <mat-icon class="copilot-context-chip__icon" aria-hidden="true">date_range</mat-icon>
              <span class="copilot-context-chip__summary">{{ periodSummary(ctx.scope) }}</span>
            </ng-container>
            <mat-icon class="copilot-context-chip__chevron" aria-hidden="true">chevron_right</mat-icon>
          </button>

          <button
            *ngIf="ctx.liveData === 'disconnected'"
            type="button"
            class="copilot-livedata-hint"
            (click)="onConnectLiveDataFromHint()"
          >
            <mat-icon aria-hidden="true">cloud_off</mat-icon>
            <span>{{ 'copilot.liveData.connectHint' | translate }}</span>
          </button>
        </ng-container>
      </div>
    </ng-template>

    <ng-template #composerForm>
    <button
      *ngIf="!showFirstRunTips && panelView === 'chat'"
      type="button"
      class="copilot-quick-tips-restore"
      (click)="restoreFirstRunTips()"
    >
      {{ 'copilot.firstRun.title' | translate }}
    </button>
    <form class="copilot-composer" (ngSubmit)="onSubmit()">
      <div class="copilot-first-run" *ngIf="showFirstRunTips && panelView === 'chat'">
        <div class="copilot-first-run__header">
          <span class="copilot-first-run__title">{{ 'copilot.firstRun.title' | translate }}</span>
          <button
            type="button"
            mat-icon-button
            class="copilot-first-run__dismiss"
            [attr.aria-label]="'copilot.firstRun.dismiss' | translate"
            (click)="dismissFirstRunTips()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="copilot-first-run__tips">
          <button type="button" class="copilot-first-run__tip" (click)="onFirstRunTipMention()">
            <mat-icon>alternate_email</mat-icon>
            <span>{{ 'copilot.firstRun.mentionTip' | translate }}</span>
          </button>
        </div>
      </div>

      <div class="copilot-composer__field" [class.copilot-composer__field--busy]="(isSending$ | async) === true">
        <app-mention-composer
          #mentionComposer
          class="copilot-mention-composer"
          [class.copilot-mention-composer--highlight]="(activeClarification$ | async) === 'user' || (activeClarification$ | async) === 'team'"
          [disabled]="(isSending$ | async) === true"
          [mentionsEnabled]="mentionsEnabled"
          [placeholder]="composerPlaceholder"
          sendIcon="arrow_upward"
          (submitComposer)="onComposerSubmit($event)"
          (mentionNeedsConfirm)="onMentionNeedsConfirm($event)"
          (wireChange)="onComposerInteraction()"
        ></app-mention-composer>
      </div>
      <button
        *ngIf="(panelScope$ | async) as scope"
        type="button"
        class="copilot-scope-context"
        [class.copilot-scope-context--hidden]="
          !scopeContextSummary(scope) ||
          (liveData$ | async) === 'connected' ||
          (liveData$ | async) === 'connecting'
        "
        (click)="openContextDrawer()"
      >
        {{ scopeContextSummary(scope) }}
      </button>
    </form>
    </ng-template>
  </div>
  </app-sidepanel>

  <div
    class="copilot-context-backdrop"
    *ngIf="contextDrawerOpen"
    (click)="closeContextDrawer()"
    aria-hidden="true"
  ></div>
  <aside
    class="copilot-context-drawer"
    [class.copilot-context-drawer--open]="contextDrawerOpen"
    [attr.aria-hidden]="!contextDrawerOpen"
    role="dialog"
    [attr.aria-label]="'copilot.context.configure' | translate"
  >
    <div class="copilot-context-drawer__header">
      <h2 class="copilot-context-drawer__title">{{ 'copilot.context.configure' | translate }}</h2>
      <div class="copilot-context-drawer__header-actions">
        <button
          type="button"
          mat-stroked-button
          class="copilot-context-drawer__cancel"
          (click)="onContextDrawerCancel()"
        >
          {{ 'common.cancel' | translate | uppercase }}
        </button>
        <button
          type="button"
          mat-raised-button
          color="primary"
          class="copilot-context-drawer__save"
          [disabled]="!hasContextChanges"
          (click)="onContextDrawerSave()"
        >
          {{ 'common.save' | translate | uppercase }}
        </button>
      </div>
    </div>

    <div class="copilot-context-drawer__body" *ngIf="liveDataContext$ | async as ctx">
      <section
        *ngIf="multiPersonaEnabled"
        class="copilot-context-drawer__section"
        aria-labelledby="copilot-context-personality"
      >
        <h3 id="copilot-context-personality" class="copilot-context-drawer__section-title">
          {{ 'copilot.intelligence.title' | translate }}
        </h3>

        <mat-form-field appearance="fill" class="copilot-context-drawer__mat-field">
          <mat-label>{{ 'copilot.advisors.selectorLabel' | translate }}</mat-label>
          <mat-select
            panelClass="copilot-intelligence-select-panel"
            [(ngModel)]="agentSettings.advisorPersona"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="(isSending$ | async) === true"
            (ngModelChange)="onPersonalityChange($event)"
          >
            <mat-option *ngFor="let option of personalityOptions" [value]="option.id">
              {{ option.labelKey | translate }} — {{ option.subtitleKey | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </section>

      <section
        class="copilot-context-drawer__section"
        *ngIf="ctx.liveData === 'connected' || ctx.liveData === 'connecting'"
        aria-labelledby="copilot-context-period"
      >
        <h3 id="copilot-context-period" class="copilot-context-drawer__section-title">
          {{ 'copilot.scope.configure' | translate }}
        </h3>

        <div class="copilot-context-drawer__dates">
          <mat-form-field appearance="fill" class="copilot-context-drawer__mat-field" (click)="openFromPicker()">
            <mat-label>{{ 'common.from' | translate }}</mat-label>
            <input
              matInput
              type="text"
              [value]="dateFromDisplayValue"
              [disabled]="(isSending$ | async) === true"
              placeholder="DD/MM/YYYY"
              (blur)="onDateFromTextBlur($event)"
              (keydown.enter)="$any($event.target).blur()"
            />
            <button mat-icon-button matSuffix type="button"
              [disabled]="(isSending$ | async) === true"
              (click)="openFromPicker()">
              <mat-icon>calendar_today</mat-icon>
            </button>
          </mat-form-field>
          <input
            #dateFromInput
            type="date"
            class="copilot-context-drawer__date-picker-hidden copilot-context-drawer__date-picker-hidden--from"
            [value]="dateFromValue"
            [max]="maxSelectableDate"
            [disabled]="(isSending$ | async) === true"
            (change)="onDateFromChange($event)"
          />
          <mat-form-field appearance="fill" class="copilot-context-drawer__mat-field" (click)="openToPicker()">
            <mat-label>{{ 'common.to' | translate }}</mat-label>
            <input
              matInput
              type="text"
              [value]="dateToDisplayValue"
              [disabled]="(isSending$ | async) === true"
              placeholder="DD/MM/YYYY"
              (blur)="onDateToTextBlur($event)"
              (keydown.enter)="$any($event.target).blur()"
            />
            <button mat-icon-button matSuffix type="button"
              [disabled]="(isSending$ | async) === true"
              (click)="openToPicker()">
              <mat-icon>calendar_today</mat-icon>
            </button>
          </mat-form-field>
          <input
            #dateToInput
            type="date"
            class="copilot-context-drawer__date-picker-hidden copilot-context-drawer__date-picker-hidden--to"
            [value]="dateToValue"
            [max]="maxSelectableDate"
            [min]="dateFromValue || null"
            [disabled]="(isSending$ | async) === true"
            (change)="onDateToChange($event)"
          />
        </div>

        <p *ngIf="ctx.scope.timezone as tz" class="copilot-context-drawer__tz" [title]="'copilot.scope.timezone' | translate">
          <mat-icon>schedule</mat-icon>
          {{ tz }}
        </p>

        <div class="copilot-scope__presets">
          <button
            *ngFor="let preset of scopePresets"
            type="button"
            class="copilot-scope__preset"
            [class.copilot-scope__preset--active]="activePresetId === preset.id"
            [disabled]="(isSending$ | async) === true"
            (click)="onScopePresetClick(preset)"
          >
            {{ preset.labelKey | translate }}
          </button>
        </div>
      </section>

      <p class="copilot-context-drawer__note" *ngIf="ctx.liveData === 'disconnected'">
        {{ 'copilot.context.connectForDates' | translate }}
      </p>
    </div>

  </aside>
</div>
